import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RowSelector from './RowSelector'
import styles from './styles.styl'

export default class RowSelectorTd extends Component {
  static propTypes = {
    enabled: PropTypes.bool,
    selected: PropTypes.bool,
    setSelected: PropTypes.func.isRequired
  }

  render() {
    return (
      <td className={styles.tdRowSelector}>
        <RowSelector {...this.props} />
      </td>
    )
  }
}
